import {Link} from '@primer/components'
import styled from 'styled-components'

// import {display, themeGet} from 'styled-system'

const ButtonGreen = styled(Link)`
  color: #fff;
  background-color: #2EBC4F;
  display: inline-block;
  border-radius: 3px;
  padding: 14px 24px;
  &:hover {
    background-color: #28a745;
    text-decoration: none;
  }
`

export default ButtonGreen
